import axios from "axios";
import ENDPOINT from "../../context/EndPoint";

// Clears a user's attempt for a test (used by "Delete" and "Attempt again").
const ResetTestAttempt = async ({ payload }) => {
  const data = new FormData();
  data.append("session", payload.session);
  data.append("test_code", payload.test_code);
  data.append("user_id", payload.user_id);

  const res = await axios.post(ENDPOINT + "admin-reset-test-attempt.php", data, {
    headers: { "content-type": "multipart/form-data" },
  });
  return res ? res.data : null;
};

export default ResetTestAttempt;
